export default __webpack_public_path__ + "static/media/LicenseKey.5a4e85f4.jpg";